import { render, staticRenderFns } from "./kpi-grid.vue?vue&type=template&id=4413fb10&scoped=true&"
import script from "./kpi-grid.vue?vue&type=script&lang=js&"
export * from "./kpi-grid.vue?vue&type=script&lang=js&"
import style0 from "./kpi-grid.vue?vue&type=style&index=0&id=4413fb10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4413fb10",
  null
  
)

export default component.exports